import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {OverlayPanelComponent} from '../components/overlay-panel/overlay-panel.component';
import {VivoService} from '../vivo/vivo.service';
import {Subject} from 'rxjs';
import {NotificationService} from '../components/notification/notification.service';
import {SidebarService} from '../shared/sidebar/sidebar.service';
import {SidebarPanelComponent} from '../sidebar/sidebar-panel/sidebar-panel.component';
import {AppMessageService} from '../shared/app-message/app-message.service';
import {LandingPageTile} from '../shared/tiles/home-tile.model';
import {_} from '../shared/utils';
import {subDays, addDays} from 'date-fns/esm';
import {NotificationEntry} from '../components/notification/notification.model';
import { takeUntil } from 'rxjs/operators';
import { TrainFidelityDbComponent } from '~app/custom/vrgroup/dashboards/train-fidelity-db/train-fidelity-db.component';

@Component({
  selector: 'qm-today',
  templateUrl: './today.component.html',
  styleUrls: ['./today.component.scss']
})
export class TodayComponent extends SidebarPanelComponent implements OnInit, OnDestroy {
  private static tileResize: Subject<[number, number]> = new Subject();

  @ViewChild('todayOverlay')
  public overlay: OverlayPanelComponent;
  public plotWidth = window.innerWidth > 2000 ? '370' : '290';
  public vivoCount: number;
  public notificationCount: number;
  public diaryEvents: number;
  public notifications: NotificationEntry[] = [];
  public comments: Map<string, any> = new Map();

  @ViewChild(TrainFidelityDbComponent)
  private trainFidelity: TrainFidelityDbComponent;

  private ngUnsubscribe: Subject<void> = new Subject();

  constructor(private vivoService: VivoService,
              private notificationService: NotificationService,
              private changeDetector: ChangeDetectorRef,
              protected sidebarService: SidebarService,
              protected appMessageService: AppMessageService) {
    super(appMessageService);
    this.componentName = TodayComponent.getComponentName();
  }

  public static initTile(tile: LandingPageTile) {
    tile.description = _('Today');
    tile.icon = 'far fa-stream';
    tile.title = _('Today');
    tile.panel = TodayComponent.getComponentName();
    tile.onResize = (width: number, height: number) => this.tileResize.next([width, height]);
  }

  private static getComponentName(): string {
    return 'Today';
  }

  ngOnInit() {
    this.prepareDiary();
    this.prepareWhiteboard();

    TodayComponent.tileResize.pipe(takeUntil(this.ngUnsubscribe)).subscribe(([width, height]) => {
      if (this.trainFidelity) {
        this.trainFidelity.onResize(width, height);
      }
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public toggleSidebarPanel(panel: string) {
    this.sidebarService.requestSidebarPanel(panel);
  }

  public async prepareDiary() {
    const body = {
      page: '1',
      limit: 15,
      startDate: subDays(new Date(), 4),
      endDate: new Date(),
      filters: [
        {
          property: {
            _id: 'taskType',
            type: 'taskType'
          },
          value: {
            _id: this.vivoService.getDiaryTaskType()
          }
        }
      ],
      viewOptions: {
        orderby: 'updatedAt',
        reverse: true
      }
    };
    const result = await this.vivoService.getDiaryEvents(body);
    this.diaryEvents = result.docs.length;
  }

  public async prepareWhiteboard() {
    const start = addDays(new Date(), 1);
    const body = {
      updatedAt_lte: start.toISOString().split('T')[0],
      updatedAt_gte: subDays(start, 7).toISOString().split('T')[0]
    };
    const r = await this.notificationService.filter(body);
    if (r.isOk) {
      this.notifications = r.data;
      this.notifications.reverse();
      this.notificationCount = this.notifications.length;
    }
  }
}
